<template>
  <div>


<h2 class="goth">Om - ob / wenn</h2>

<div class="grammatikparagrafbredd leftorient">
<p>När svenskan använder ordet <i>om</i> som konjunktion, kan de på tyska motsvaras av <i>ob</i> respektive <i>wenn</i>
som har olika användingsområden.</p>




<br>
<h4><i>ob</i></h4>
<div class="quasi-p"> används <b>vid osäkerhet om innehållet</b> i kommande bisats.

</div>



<div class="ruta">
<p><i>Det är ännu oklart, <b>om</b> medicinerna fungerar</i></p>

<p><i>Es ist noch unklar, <b>ob</b> die Medikamente funktionieren.</i></p>

</div>


<p>I sådana meningar kan man
lägga till <i>"eller inte"</i> för att förtydliga. I exemplet ovan kunde man sagt:<br></p>



<div class="ruta">
<p><i>Det är ännu oklart, <b>om</b> medicinerna fungerar <b>eller inte</b></i>.</p>
</div>


<p class="mindre">I de fall man på svenska kan ersätta <i>om</i> med <i><b>huruvida</b></i> och få samma betydelse,
    används <b><i>ob</i></b> på tyska.</p>



<br>

<h4><i>wenn</i></h4>
<p>används då när ett <b>vilkor skall vara uppfyllt</b>
för att innehållet i huvudsatsen skall gälla:</p>


<div class="ruta">

<p><i>Wir fahren morgen zum Strand, <b>wenn</b> die Sonne scheint.</i></p>

    <i>Vi åker till stranden i morgon, <b>om</b> solen skiner  <div class="inlajn mindre"> (... men bara då, annars stannar vi hemma)</div></i>"</div>

</div>

</div>







</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "ob wenn om huruvida"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
